import { useState, type FormEvent } from 'react';
import { supabase } from '../lib/supabase.ts';
import { friendlyMessage } from '../lib/errors.ts';

export function LoginPage() {
  const [mode, setMode] = useState<'login' | 'signup'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [info, setInfo] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    setInfo(null);
    try {
      if (mode === 'login') {
        const { error: err } = await supabase.auth.signInWithPassword({
          email: email.trim(),
          password,
        });
        if (err) throw err;
      } else {
        const { data, error: err } = await supabase.auth.signUp({
          email: email.trim(),
          password,
          options: { emailRedirectTo: window.location.origin },
        });
        if (err) throw err;
        if (!data.session) setInfo('Te enviamos un correo para confirmar la cuenta.');
      }
    } catch (err) {
      setError(friendlyMessage(err));
    } finally {
      setBusy(false);
    }
  }

  async function google() {
    setError(null);
    const { error: err } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin,
        queryParams: { hd: 'lab51.cl', prompt: 'select_account' },
      },
    });
    if (err) setError(friendlyMessage(err));
  }

  return (
    <main className="auth">
      <div className="auth-card">
        <h1>Tablero</h1>
        <p className="muted">Ingresa con tu cuenta de Lab51.</p>
        <button type="button" className="button button-google" onClick={() => void google()}>
          Continuar con Google
        </button>
        <div className="divider">
          <span>o con correo</span>
        </div>
        <form onSubmit={(e) => void submit(e)} className="form">
          <label>
            Correo
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label>
            Contraseña
            <input
              type="password"
              autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
              required
              minLength={mode === 'signup' ? 10 : undefined}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          {error && (
            <p className="form-error" role="alert">
              {error}
            </p>
          )}
          {info && <p className="form-info">{info}</p>}
          <button type="submit" className="button button-primary" disabled={busy}>
            {mode === 'login' ? 'Ingresar' : 'Crear cuenta'}
          </button>
        </form>
        <button
          type="button"
          className="link-button"
          onClick={() => {
            setMode(mode === 'login' ? 'signup' : 'login');
            setError(null);
          }}
        >
          {mode === 'login' ? '¿Primera vez? Crea tu cuenta' : 'Ya tengo cuenta'}
        </button>
      </div>
    </main>
  );
}
